import { useState } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { BLOCKS } from '@contentful/rich-text-types';
import { AccordionItem } from 'react-accessible-accordion';

import RichText from '../RichText';

import {
  AccordionWrapper,
  StyledAccordionItemTitle,
  StyledAccordionItemButton,
  StyledAccordionBody,
  AccordionText,
} from './styles';

const text = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <AccordionText>{children}</AccordionText>
    ),
  },
};

const Accordion = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { paragraphHeading, paragraph } = data;
  return (
    <AccordionWrapper allowMultipleExpanded allowZeroExpanded>
      <AccordionItem>
        <StyledAccordionItemTitle
          onClick={() => {
            if (isOpen) {
              setIsOpen(false);
            } else {
              setIsOpen(true);
            }
          }}
        >
          <StyledAccordionItemButton>
            <div>
              {ReactHtmlParser(paragraphHeading.childMarkdownRemark.html)}
            </div>
          </StyledAccordionItemButton>
        </StyledAccordionItemTitle>
        <StyledAccordionBody>
          <RichText document={paragraph} options={text} />
        </StyledAccordionBody>
      </AccordionItem>
    </AccordionWrapper>
  );
};

Accordion.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default Accordion;
